export function getLuminanceColor(r, g, b) {
    
    // Normaliser les valeurs R, G, B entre 0 et 1
    const rNorm = r / 255;
    const gNorm = g / 255;
    const bNorm = b / 255;

    // Calculer la luminosité relative
    const luminance = 0.2126 * rNorm + 0.7152 * gNorm + 0.0722 * bNorm;

    console.log('luminance',luminance)
    return luminance
}

export function adjustColorBrightness(r, g, b, adjustmentFactor) {
    // Appliquer le facteur d'ajustement et restreindre les valeurs entre 0 et 255
    const newR = Math.min(255, Math.max(0, Math.round(r * adjustmentFactor)));
    const newG = Math.min(255, Math.max(0, Math.round(g * adjustmentFactor)));
    const newB = Math.min(255, Math.max(0, Math.round(b * adjustmentFactor)));
    return [newR,newG,newB];
}


export function increase_brightness(r, g, b, percent){
    return '#' +
    ((0|(1<<8) + r + (256 - r) * percent / 100).toString(16)).substr(1) +
    ((0|(1<<8) + g + (256 - g) * percent / 100).toString(16)).substr(1) +
    ((0|(1<<8) + b + (256 - b) * percent / 100).toString(16)).substr(1);
}

export const hex2rgb = (hex) => {
    const rgbChar = ['r', 'g', 'b'];
    
    const normal = hex.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i);
    if (normal) {
      return normal.slice(1).reduce((a, e, i) => { 
        a[rgbChar[i]] = parseInt(e, 16); 
        return a;
      }, {});
    }
  
    const shorthand = hex.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i);
    if (shorthand) { 
      return shorthand.slice(1).reduce((a, e, i) => { 
        a[rgbChar[i]] = 0x11 * parseInt(e, 16); 
        return a;
      }, {});
    }
  
    return null;
}